<div *ngIf="!isLoading" [ngClass]="{ 'question-fact-modal': isModal }">
  <div [ngClass]="{ 'modal-content': isModal }">
    <div class="question-container">
      <div class="header-container" *ngIf="isModal">
        <div class="header-left">
          <div class="title">{{ translatedType }}</div>
        </div>
        <div class="header-right">
          <div class="call-details" (click)="openSidePane(objectiveResult[0] || messageAdherenceDetailsResponse[0])"
            *ngIf="questionResponse || objectiveResult?.length == 1 || messageAdherenceDetailsResponse?.length == 1">
            <div class="btn">
              {{'reporting.ALL_CALL_DETAILS' | transloco}}
              <img src="assets/icons/arrow/qnt-view-in-modal-pop-bold.svg"
                alt="{{'reporting.ALL_CALL_DETAILS' | transloco}}" />
            </div>
          </div>
          <div class="close" (click)="close()">
            <img src="assets/icons/x-close-bold.svg" alt="{{'reporting.CLOSE_ALT' | transloco}}" />
          </div>
        </div>
      </div>
      <div class="loading" *ngIf="isModal && isLoading">
        <app-three-dots-blinking></app-three-dots-blinking>
      </div>

      <ng-container *ngIf="(!isLoading &&
          type === 'Highest Scoring Question' ||
            type === 'Lowest Scoring Question') || (!isLoading && !isModal);
          else specialFact
        ">
        <ng-container *ngIf="isModal">
          <h2>Q{{questionResponse?.questionNumber}}. {{ questionResponse?.questionName }}</h2>
          <div class="call-name">{{'reporting.CALL' | transloco}}: {{ callName }}</div>
        </ng-container>

        <div class="question">
          <div class="question-no" *ngIf="!isModal">
            {{'reporting.QUESTION' | transloco}} {{ questionNumber }}
          </div>
          <div class="heading" *ngIf="!isModal">
            {{ questionResponse?.questionName }}
          </div>
          <div class="question-text" *ngIf="isModal">{{'reporting.QUESTION_TEXT_LABEL' | transloco}}:</div>
          <div class="details">{{ questionResponse?.agentSays }}</div>
          <div class="bar-container">
            <div class="average">
              <div class="title">{{'reporting.AVG_POINTS_LABEL' | transloco}}:</div>
              <div class="score-container">
                <div class="achieved-score">
                  {{
                  questionResponse?.averageQuestionScore || 0
                  | number : "1.1-2"
                  }}
                </div>

                <div class="total-score">
                  &nbsp;/&nbsp;{{ questionResponse?.totalFacts }}
                </div>
              </div>
            </div>
            <div [ngStyle]="{
                'grid-template-columns':
                  'repeat(' + (questionResponse?.totalFacts ?? 0) + ', 1fr)'
              }" class="progress-bar" *ngIf="
                calculateProgress(
                  questionResponse?.averageQuestionScore ?? 0,
                  questionResponse?.totalFacts ?? 0
                );
                let bar
              ">
              <div class="segment" *ngFor="
                  let i of [].constructor(questionResponse?.totalFacts || 0);
                  let index = index
                " [class.filled]="index < bar.filled">
                <div class="partial-fill" *ngIf="index === bar.filled && bar.partial > 0"
                  [style.width.%]="bar.partial * 100"></div>
              </div>
            </div>
          </div>
          <div class="facts-container" *ngIf="!anyFactNull; else nullFact">
            <div class="heading">{{'reporting.ANSWER_POINTS' | transloco}}</div>
            <div class="fact" *ngFor="
                let fact of questionResponse?.factDetails;
                let index = index
              " [ngClass]="{ 'first-fact': index === 0 }">
              <div class="title-container"
                [ngClass]="fact.factName && fact.factName.length > titleCharLimit ? 'bg-grey' : ''"
                (click)="fact.factName && fact.factName.length > titleCharLimit ? toggleExpand($event, fact.factName) : null">
                <div class="title" *ngIf="fact.factName"
                  [ngStyle]="{'max-width': titleCharLimit === 60 ? '493px' : '690px'}">
                  {{
                  fact.factName.length > titleCharLimit
                  ? fact.factName.slice(0, titleCharLimit) + "..."
                  : fact.factName
                  }}
                </div>
                <div *ngIf="fact.factName && fact.factName.length > titleCharLimit" class="show-all">
                  <span>{{'reporting.SHOW_ALL' | transloco}}</span>
                  <img [src]="chevronDown" alt=">" />
                </div>
              </div>
              <div class="progress-bar-container">
                <div class="progress-bar-percentage">
                  <div class="fill" [style.width.%]="fact.averageCorrect"></div>
                </div>
              </div>
              <div class="fact-details">
                <div class="details">
                  {{ fact.correctAnswers }} {{'reporting.CORRECT_ANSWER' | transloco}}
                  {{ fact.attempts }} {{'reporting.ATTEMPTS' | transloco}}.
                </div>
                <div class="percentage">{{ fact.averageCorrect }}%</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #specialFact>
        <ng-container
          *ngIf="!isLoading && type === 'Most Missed Answer Point Question' || type === 'Least Missed Answer Point Question'">
          <h2>{{ data.name }}</h2>
          <div class="call-container">
            <div><span class="call-label">{{'reporting.CALL' | transloco}}: </span>{{ callName }}</div>
            <div><span class="call-label">{{'reporting.QUESTION' | transloco}}: </span>{{'reporting.Q_LABEL' |
              transloco}}{{questionResponse?.questionNumber}}. {{
              questionResponse?.questionName }}</div>
          </div>
          <div class="scoring-container" *ngIf="!anyFactNull; else nullFact">
            <div class="label">{{'reporting.SCORING_LABEL' | transloco}}:</div>
            <div class="progress-bar-container">
              <div class="progress-bar-percentage">
                <div class="fill" [style.width.%]="filteredFact?.averageCorrect"></div>
              </div>
            </div>
            <div class="fact-details">
              <div class="details">
                {{ filteredFact?.correctAnswers }} {{'reporting.CORRECT_ANSWER' | transloco}}
                {{ filteredFact?.attempts }} {{'reporting.ATTEMPTS' | transloco}}.
              </div>
              <div class="percentage">{{ filteredFact?.averageCorrect }}%</div>
            </div>
          </div>
        </ng-container>
        <div class="objective"
          *ngIf="!isLoading && type === 'Highest Scoring Objective' || type === 'Lowest Scoring Objective'">
          <div class="heading" *ngIf="objectiveResult.length > 1">
            <h2>{{ data.name }}</h2>
            <div class="msg">
              {{'reporting.OBJECTIVE_MEASURED_ON' | transloco}} {{objectiveResult.length}} {{'reporting.CALLS_IN_MODULE'
              | transloco}}.
            </div>
          </div>

          <div class="body">
            <ng-container *ngFor="let res of objectiveResult">
              <div class="call-wrapper" [ngClass]="{'margin-md': objectiveResult.length > 1}">
                <img src="/assets/icons/phone-call-01.svg">
                <span>
                  {{ res.callName }}
                </span>
              </div>
              <h2 *ngIf="objectiveResult.length == 1">{{ data.name }}</h2>

              <div class="progress-bar" *ngIf="calculateProgress(convertToNumber(res.percentage), totalScore); let bar">
                <div class="segment" *ngFor="let i of [].constructor(totalScore); let index = index"
                  [class.filled]="index < bar.filled">
                  <div class="partial-fill" *ngIf="index === bar.filled && bar.partial > 0"
                    [style.width.%]="bar.partial * 100">
                  </div>
                </div>
              </div>
              <div class="score-container">
                <div class="achieved-score">
                  {{ res.percentage || 0 | number : "1.1-1" }}
                </div>
                <div class="total-score">&nbsp;/&nbsp;{{ totalScore }}</div>
              </div>
              <div class="call-details" (click)="openSidePane(res)">
                <div class="btn" *ngIf="objectiveResult.length > 1">
                  {{'reporting.VIEW_CALL_DETAILS' | transloco}}
                  <img src="assets/icons/arrow/qnt-view-in-modal-pop-bold.svg"
                    alt="{{'reporting.VIEW_MODAL' | transloco }}" />
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <ng-container
          *ngIf="!isLoading && type === 'Least Articulated Message' || type === 'Most Articulated Message' && messageAdherenceDetailsResponse">
          <!-- Code for message adherence -->
          <div class="message-adherence">
            <ng-container *ngFor="let call of messageAdherenceDetailsResponse">
              <div class="call">
                <img src="assets/icons/phone-call-01.svg" alt="">
                <span>{{call.callName}}</span>
              </div>
              <div class="call-name">
                {{call.name}}
              </div>
              <div class="progress-bar-container">
                <div class="progress-wrapper"
                  [ngStyle]="{ 'width': (call.articulationProgress.get('FULLY_ARTICULATED')?.percentage) + '%' }">
                  <div class="progress expert">
                  </div>
                  <div class="tooltip">
                    <img src="/assets/icons/green-circle.svg">
                    {{call.articulationProgress.get('FULLY_ARTICULATED')?.percentage}}%
                  </div>
                </div>
                <div class="progress-wrapper"
                  [ngStyle]="{ 'width': (call.articulationProgress.get('PARTIALLY_ARTICULATED')?.percentage) + '%' }">
                  <div class="progress proficient">
                  </div>
                  <div class="tooltip">
                    <img src="/assets/icons/blue-circle.svg">
                    {{call.articulationProgress.get('PARTIALLY_ARTICULATED')?.percentage}}%
                  </div>
                </div>
                <div class="progress-wrapper"
                  [ngStyle]="{ 'width': (call.articulationProgress.get('NOT_MENTIONED')?.percentage) + '%' }">
                  <div class="progress developing">
                  </div>
                  <div class="tooltip">
                    <img src="/assets/icons/yellow-circle.svg">
                    {{call.articulationProgress.get('NOT_MENTIONED')?.percentage}}%
                  </div>
                </div>
              </div>
              <div class="skills-container">
                <div class="skill">
                  <div class="round-shape"></div>
                  <span>{{call.articulationProgress.get('FULLY_ARTICULATED')?.percentage}}%
                    {{'reporting.FULLY_ARTICULATED' | transloco}}</span>
                </div>
                <div class="skill">
                  <div class="round-shape"></div>
                  <span>{{call.articulationProgress.get('PARTIALLY_ARTICULATED')?.percentage}}%
                    {{'reporting.PARTIALLY_ARTICULATED' | transloco}}</span>
                </div>
                <div class="skill">
                  <div class="round-shape"></div>
                  <span>{{call.articulationProgress.get('NOT_MENTIONED')?.percentage}}% {{'reporting.NOT_MENTIONED' |
                    transloco}}</span>
                </div>
              </div>
              <div class="call-details" (click)="openSidePane(call)">
                <div class="btn" *ngIf="messageAdherenceDetailsResponse.length > 1">
                  {{'reporting.VIEW_CALL_DETAILS' | transloco}}
                  <img src="assets/icons/arrow/qnt-view-in-modal-pop-bold.svg"
                    alt="{{'reporting.VIEW_MODAL' | transloco }}" />
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #nullFact>
        <div class="null-fact">
          <img src="assets/icons/exclaimation-circle.svg" alt="" />
          <div class="description">
            <div class="heading">{{'reporting.QUESTION_UPDATED' | transloco}}.</div>
            <div class="details">
              {{'reporting.QUESTION_UPDATED_MESSAGE' | transloco}}.
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<div [ngClass]="isModal ? 'loading' :  'loader'" *ngIf="isLoading">
  <app-three-dots-blinking></app-three-dots-blinking>
</div>